// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as I18n$LumiAuthentication from "./I18n.res.js";

function Form$Field(props) {
  let onChange = props.onChange;
  let enabled = props.enabled;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let locale = Locale$LumiI18n.useContext();
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("p", {
      children: [
        JsxRuntime.jsx("input", {
          className: "input " + className,
          autoComplete: props.autoComplete,
          disabled: !enabled,
          name: props.name,
          placeholder: I18n$LumiAuthentication.T.Text.string(locale, props.placeholder),
          required: enabled,
          type: props.type_,
          value: props.value,
          onChange: e => onChange(e.target.value)
        }),
        JsxRuntime.jsx("span", {
          children: props.icon,
          className: "icon is-small is-left"
        })
      ],
      className: "control has-icons-left"
    }),
    className: "field"
  });
}

let Field = {
  make: Form$Field
};

function Form$EmailField(props) {
  let __enabled = props.enabled;
  let value = props.value;
  let enabled = __enabled !== undefined ? __enabled : true;
  let error = value !== "" && !props.valid;
  return JsxRuntime.jsx(Form$Field, {
    type_: "email",
    name: "email",
    autoComplete: "username",
    value: value,
    className: error ? "is-danger" : "",
    placeholder: "PhraseEmail",
    enabled: enabled,
    onChange: props.onChange,
    icon: JsxRuntime.jsx(FontAwesome$Web.Regular.make, {
      name: "envelope"
    })
  });
}

let EmailField = {
  make: Form$EmailField
};

function Form$ExistingPasswordField(props) {
  let __enabled = props.enabled;
  let value = props.value;
  let enabled = __enabled !== undefined ? __enabled : true;
  let error = value !== "" && !props.valid;
  return JsxRuntime.jsx(Form$Field, {
    type_: "password",
    name: "password",
    autoComplete: "current-password",
    value: value,
    className: error ? "is-danger" : "",
    placeholder: "PhrasePassword",
    enabled: enabled,
    onChange: props.onChange,
    icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
      name: "lock"
    })
  });
}

let ExistingPasswordField = {
  make: Form$ExistingPasswordField
};

function Form$NewPasswordField(props) {
  let __enabled = props.enabled;
  let value = props.value;
  let enabled = __enabled !== undefined ? __enabled : true;
  let error = value !== "" && !props.valid;
  return JsxRuntime.jsx(Form$Field, {
    type_: "password",
    name: "new-password",
    autoComplete: "new-password",
    value: value,
    className: error ? "is-danger" : "",
    placeholder: "PhraseEnterNewPassword",
    enabled: enabled,
    onChange: props.onChange,
    icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
      name: "lock"
    })
  });
}

let NewPasswordField = {
  make: Form$NewPasswordField
};

function Form$VerifyPasswordField(props) {
  let __enabled = props.enabled;
  let value = props.value;
  let enabled = __enabled !== undefined ? __enabled : true;
  let error = value !== "" && !props.valid;
  return JsxRuntime.jsx(Form$Field, {
    type_: "password",
    name: "verify-password",
    autoComplete: "new-password",
    value: value,
    className: error ? "is-danger" : "",
    placeholder: "PhraseEnterNewPasswordAgain",
    enabled: enabled,
    onChange: props.onChange,
    icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
      name: "lock"
    })
  });
}

let VerifyPasswordField = {
  make: Form$VerifyPasswordField
};

function Form$Submit(props) {
  let __enabled = props.enabled;
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let enabled = __enabled !== undefined ? __enabled : true;
  let locale = Locale$LumiI18n.useContext();
  return JsxRuntime.jsx("input", {
    className: LumiReact.classList(classList),
    disabled: !enabled,
    type: "submit",
    value: I18n$LumiAuthentication.T.Text.string(locale, props.label)
  });
}

let Submit = {
  make: Form$Submit
};

function Form$Message(props) {
  return LumiReact.renderOption(undefined, props.message, message => JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("p", {
      children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
        entry: message
      })
    }),
    className: "notification is-info"
  }));
}

let Message = {
  make: Form$Message
};

function Form$Error(props) {
  return LumiReact.renderOption(undefined, props.error, err => JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("p", {
      children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
        entry: err
      })
    }),
    className: "notification is-danger"
  }));
}

let $$Error = {
  make: Form$Error
};

let T;

export {
  T,
  Field,
  EmailField,
  ExistingPasswordField,
  NewPasswordField,
  VerifyPasswordField,
  Submit,
  Message,
  $$Error,
}
/* LumiReact Not a pure module */
